// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"MobileHotelDetails_listContainer__F38cG","psaBanner":"MobileHotelDetails_psaBanner__6NvMq","poolHours":"MobileHotelDetails_poolHours__YJhNs"};